import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';

function SubscriptionInfo()
{
    return(
        <>
        SubscriptionInfo
        </>
    )
}

const mapStateToProps = state => ({
    token: state.loggedUser.token,
    stores: state.accountOverview.landing.adProfiles,
})

export default connect(mapStateToProps)(SubscriptionInfo);